import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

export type AuthSessionState = 'ACTIVE' | 'EXPIRED';

@Injectable({ providedIn: 'root' })
export class AuthSessionStateService {
  private readonly subject$ = new BehaviorSubject<AuthSessionState>(
    this.hasAuthenticationCookies() ? 'ACTIVE' : 'EXPIRED'
  );

  readonly state$: Observable<AuthSessionState> = this.subject$.asObservable();

  constructor(private cookies: CookieService) {}

  get isActive(): boolean {
    return this.subject$.getValue() === 'ACTIVE' && this.hasAuthenticationCookies();
  }

  markActive(): void {
    this.subject$.next('ACTIVE');
  }

  markExpired(): void {
    if (this.subject$.getValue() === 'EXPIRED') {
      return;
    }
    this.subject$.next('EXPIRED');
  }

  syncFromCookies(): void {
    if (this.hasAuthenticationCookies()) {
      this.markActive();
    }
  }

  private hasAuthenticationCookies(): boolean {
    return !!this.cookies.get('tokenId') && !!this.cookies.get('userId');
  }
}
